export default "__VITE_ASSET__BKjQ9sAI__"